var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"pt-2 pb-2"},[_c('PoisForm',{staticClass:"align-content-center"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }